const initialized = new WeakSet();

export default function init(element) {
    if (initialized.has(element)) {
        return;
    }
    const doc = element.ownerDocument;
    initialized.add(element);

    // Register component events on element, rather than document.
    (function () {
        const sendHeaderTitle = () => {
            const headerTextEl = doc.querySelector('.permission-monitor-header .sheet-text');
            if (!headerTextEl) {
                return;
            }

            const titleText = headerTextEl.textContent?.trim();
            if (!titleText) {
                return;
            }

            window.dispatchEvent(
                new CustomEvent('amsOsramPermissionMonitorAssignRolesTitle', {
                    detail: {
                        titleText,
                    },
                })
            );
        };

        if (doc.readyState === 'complete' || doc.readyState === 'interactive') {
            sendHeaderTitle();
        } else {
            doc.addEventListener('DOMContentLoaded', sendHeaderTitle);
        }
    })();
}
